import { IconName } from 'components/atoms/Icon/types'
import { useAuthContext } from 'contexts/auth'
import { hasPermission } from 'utils/permissions/PermissionGate'
import { permissions } from 'utils/permissions/permissionsMap'

interface IList {
    label: string
    icon: IconName | string
    href: string | '/'
}

export const NavigationList = () => {
    const { isBackoffice } = useAuthContext()

    const labelInstitutions = isBackoffice ? 'Instituições' : 'Instituição'

    const acessRouteInstitution = hasPermission([
        permissions.instituicao.leitura
    ])
    const acessRouteAF = hasPermission([permissions.af.leitura])
    const acessRouteUsers = hasPermission([permissions.usuario.leitura])
    const acessRouteContract = hasPermission([permissions.contrato.leitura])
    const accessRouteFeeManagement = hasPermission([
        permissions.gestaoTaxas.leitura
    ])
    const accessRouteNotifications = hasPermission([
        permissions.contrato.leitura
    ])
    const accessRoutePerformaceIndicators = hasPermission([
        permissions.gestaoTaxas.leitura
    ])
    return [
        ...(acessRouteInstitution
            ? [
                  {
                      label: labelInstitutions,
                      icon: 'building',
                      href: '/instituicoes'
                  }
              ]
            : []),
        ...(acessRouteAF
            ? [
                  {
                      label: 'Agentes Financeiros',
                      icon: 'financial-agent',
                      href: '/agentes-financeiros'
                  }
              ]
            : []),
        ...(acessRouteUsers
            ? [
                  {
                      label: 'Usuários',
                      icon: 'user',
                      href: '/usuarios'
                  }
              ]
            : []),

        ...(acessRouteContract
            ? [
                  {
                      label: 'Contratos',
                      icon: 'briefcase',
                      href: '/contratos'
                  }
              ]
            : []),
        ...(acessRouteContract
            ? [
                  {
                      label: 'Consulta de Contratos',
                      icon: 'search',
                      href: '/consulta-contratos'
                  }
              ]
            : []),            
        {
            label: 'Relatórios',
            icon: 'file-alt',
            href: '/relatorio'
        },
        ...(acessRouteContract
            ? [
                  {
                      label: 'Veículos',
                      icon: 'car',
                      href: '/veiculos'
                  }
              ]
            : []),             
        ...(accessRouteFeeManagement
            ? [
                  {
                      label: 'Gestão de Taxas',
                      icon: 'management-fee',
                      href: '/gestao-taxas'
                  }
              ]
            : []),
        ...(accessRoutePerformaceIndicators
            ? [
                  {
                      label: 'Financeiro',
                      icon: 'indicators',
                      href: '/relatorio-financeiro'
                  }
              ]
            : []),
        ...(accessRouteNotifications
            ? [
                  {
                      label: 'Comunicação',
                      icon: 'bell',
                      href: '/comunicacao'
                  }
              ]
            : []),
        ...(accessRoutePerformaceIndicators
            ? [
                  {
                      label: 'Gestão de Acessos',
                      icon: 'house',
                      href: '/relatorio-gestao'
                  }
              ]
            : [])
    ] as IList[]
}
